const drawerWidth = 350;
export { drawerWidth };
